<template>
  <v-form ref="commentform" v-model="valid" lazy-validation>
    <v-container fluid>
      <v-layout row wrap justify-center align-space-around justify-space-around>
        <v-flex sm1
          ><v-btn flat @click="exit()"
            ><v-icon>arrow_back_ios</v-icon>&nbsp;Back</v-btn
          ></v-flex
        >
        <v-flex sm11 md5>
          <v-date-picker v-model="date" landscape reactive> </v-date-picker>
        </v-flex>

        <v-flex sm12 md6>
          <v-textarea
            outline
            label="Milestone"
            :rules="[(v) => !!v || 'A milestone is required']"
            v-model="text"
            required
          >
          </v-textarea>
        </v-flex>
      </v-layout>
      <div class="text-sm-center">
        <v-btn color="primary" dark @click="submit">submit</v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "CreateCommentPOG",

  props: {
    comment: {
      type: Object,
      default() {
        return {
          date: null,
          text: null,
        };
      },
    },
  },

  beforeMount() {
    this.date = this.comment.date;
    this.text = this.comment.text;
  },

  data() {
    return {
      date: null,
      text: null,
      valid: true,
    };
  },

  methods: {
    exit() {
      this.$emit("create-comment", null);
    },
    submit() {
      if (this.$refs.commentform.validate() && this.date) {
        this.$emit("create-comment", { date: this.date, text: this.text });
      } else {
        this.$emit("show-message", "Select a date and enter a milestone", "red");
      }
    },
  },
};
</script>

<style scoped>
</style>
